import { FC } from 'react';
import * as React from 'react';
import {ReactComponent as MinusIcon} from '@iba-team/portal-react-components/dist/svg/outline/minus.svg';
import {ReactComponent as PlusIcon} from '@iba-team/portal-react-components/dist/svg/outline/plus.svg';
import './InputNumberStyles.scss';
import { Divider } from '@iba-team/portal-react-components/dist';
interface InputNumberI{
  value?: number,
  onChange: (value: number) =>  void,
  min?: number,
  max?: number,
  placeholder?: string
}

export const InputNumber: FC<InputNumberI> = (props) => {
  const increment = () => {
    if(props.value !== undefined){
      const next = props.value + 1;
      if(props.max === undefined || (next <= props.max)){
        props.onChange(next);
      }
    }
    else{
      props.onChange(props.min ? props.min + 1 : 1);
    }
  };

  const decrement = () => {
    if(props.value !== undefined){
      const next = props.value - 1;
      if(props.min === undefined || (next >= props.min)){
        props.onChange(next);
      }
    }
    else{
      props.onChange(props.min ? props.min - 1 : -1);
    }
  };
  return (
    <div className={'garr-input-number'}>
      <input type={'number'}
        value={props.value}
        min={props.min}
        placeholder={props.placeholder}
        onChange={(e) => {
          props.onChange(+e.target.value);
        }}/>
      <MinusIcon onClick={decrement}/>
      <Divider variant={'VERTICAL'}/>
      <PlusIcon onClick={increment}/>
    </div>

  );
};